/**
 * FullCalendar plugin initialization (Schedule)
 * @requires https://github.com/fullcalendar/fullcalendar
 */

import vendorMissing from './vendor-missing'

export default (() => {
  // forEach function
  const forEach = (array, callback, scope) => {
    for (let i = 0; i < array.length; i++) {
      callback.call(scope, i, array[i]) // passes back stuff we need
    }
  }

  // Calendar initialisation
  const calendars = document.querySelectorAll('.calendar')
  if (calendars.length === 0) return
  if (vendorMissing('calendar', { FullCalendar: typeof FullCalendar })) return

  forEach(calendars, (index, value) => {
    let userOptions
    if (value.dataset.calendarOptions != undefined)
      userOptions = JSON.parse(value.dataset.calendarOptions)
    let options = {
      themeSystem: 'bootstrap5',
      ...userOptions,
    }

    /* eslint-disable no-undef */
    const calendarInstance = new FullCalendar.Calendar(value, options)
    /* eslint-enable no-undef */
    calendarInstance.render()
  })
})()
